import type {
  CustomEventProperties,
  SegmentTrackData,
} from '@hotjar/webapp/domains/common/tracking/segment';

// FIXME: camelcase
/* eslint-disable camelcase */

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `segment` namespace.
 */
export const FormSubmittedEventData = (
  app_form_name: string,
  app_form_submit_success: boolean,
  groupData: CustomEventProperties,
): SegmentTrackData => ({
  app_form_name,
  app_form_submit_success,
  ...groupData,
});

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `segment` namespace.
 */
export const SubscriptionPausedEventData = (
  account_id: string,
  user_id: string,
  pause_reason: string,
): SegmentTrackData => ({
  account_id,
  user_id,
  pause_reason,
});

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `segment` namespace.
 * FIXME: Please fix this. You may refer to CFE-266 for more details.
 */
// eslint-disable-next-line func-params-args/func-params
export const ChurnSurveySubmittedEventData = (
  account_id: string,
  user_id: string,
  downgrade_reason: string,
  downgrade_explanation: string,
  likely_to_upgrade: boolean,
): SegmentTrackData => ({
  account_id,
  user_id,
  downgrade_reason,
  downgrade_explanation,
  likely_to_upgrade,
});
